interface SubType {
  sub_type_label: string;
  sub_type_value: string;
}

interface PayerMapping {
  insurance_name: string;
  insurance_value: string;
  sub_types: SubType[];
}

interface PayerSubtypesData {
  mapping: PayerMapping[];
}

export interface SelectOption {
  label: string;
  value: string;
}

/**
 * Extracts insurance options from payer subtypes data
 * @param payerSubtypes - The payer subtypes data from Firestore
 * @returns Array of insurance options for Select component
 */
export const extractInsuranceOptions = (payerSubtypes: any): SelectOption[] => {
  const data = payerSubtypes as PayerSubtypesData;
  return (
    data?.mapping?.map((item) => ({
      label: item.insurance_value,
      value: item.insurance_name,
    })) || []
  );
};

/**
 * Extracts plan/sub-type options for a specific insurance
 * @param payerSubtypes - The payer subtypes data from Firestore
 * @param selectedInsurance - The selected insurance name
 * @returns Array of plan options for Select component
 */
export const extractPlanOptions = (
  payerSubtypes: any,
  selectedInsurance: string,
): SelectOption[] => {
  const data = payerSubtypes as PayerSubtypesData;
  const insurance = data?.mapping?.find(
    (item) => item.insurance_name === selectedInsurance,
  );

  return (
    insurance?.sub_types?.map((subType) => ({
      label: subType.sub_type_value,
      value: subType.sub_type_label,
    })) || []
  );
};
